import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
// @ts-ignore react-pdf v5 ships incomplete TypeScript types
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

interface PdfViewProps {
  pdfBlob: Blob;
  onError?: (error: Error) => void;
  'test-id'?: string;
}

export function PdfView({
  pdfBlob,
  onError,
  'test-id': testId = 'pdf-view',
}: PdfViewProps) {
  const [numPages, setNumPages] = useState<number | null>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);

  // Reset the number of pages when the PDF blob changes
  useEffect(() => {
    setNumPages(null);
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, [pdfBlob]);

  // Keep a readable page size; parent Paper sizes to the page and is centered.
  const pageWidth = 850;

  return (
    <Box
      ref={containerRef}
      test-id={testId}
      sx={{
        width: pageWidth,
        maxWidth: '100%',
        height: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
        '& .react-pdf__Document': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        },
      }}
    >
      <Document
        file={pdfBlob}
        onLoadSuccess={({ numPages: nextNumPages }: { numPages: number }) => {
          setNumPages(nextNumPages);
          if (containerRef.current) {
            containerRef.current.scrollTop = 0;
          }
        }}
        onLoadError={(error: Error) => {
          console.error(error);
          onError?.(error);
        }}
        loading="Loading PDF..."
        error="Unable to display PDF."
      >
        {numPages != null &&
          Array.from(new Array(numPages), (_el, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              width={pageWidth}
            />
          ))}
      </Document>
    </Box>
  );
}
